import axios from '@/plugins/axios';

export function findPaymentList(params) {
  return axios.post('/payment/findPaymentList', params);
}
